<template>
  <div id="app" v-bind:class="{'hasFixedMenu': fixed}">
    <div class="ui top fixed menu inverted" v-bind:class="{ 'ui top menu inverted': true, 'fixed': fixed }">
      <div class="ui container stackable">
        <div class="left menu" v-if="!user">
          <router-link to="/welcome" class="item narrow">
            <i title="take a photo" class="home icon"></i>
          </router-link>
        </div>
        <div class="left menu" v-if="user">
          <router-link to="/capture" class="item narrow">
            <i title="take a photo" class="camera retro icon big"></i>
          </router-link>
          <router-link to="/items" class="item">
            <i title="boxes" class="boxes icon big"></i>
            Your Stuff (${{totalValue}})
          </router-link>
          <!-- <router-link to="/photos" class="item"><i title="images" class="images icon big"></i></router-link> -->
          <!-- <router-link to="/organize" class="item"><i title="organize" class="images icon big"></i></router-link> -->
        </div>
        <div class="right menu">
          <router-link to="/login" class="item narrow" v-if="!user"><i title="login" class="sign-in icon"></i></router-link>
          <router-link to="/account" class="item narrow" v-if="user"><i title="logout" class="user icon"></i></router-link>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <!-- <div class="ui grid"> -->
      <div class="ui container">
        <router-view/>
      </div>
      <!-- </div> -->
    </div>

    <div class="ui bottom menu">
      <div class="right menu">
          <router-link to="/terms" class="item narrow">Terms / Privacy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
      return {
          fixed: true
      };
  },
  computed: {
      ...mapGetters({
        user: 'getUser',
        account: 'AccountModule/get',
        // galleries: 'GalleryModule/get',
        // photos: 'PhotoModule/get',
        items: 'ItemModule/get',
      }),
      mainAccount: function() {
        return this.account.filter(account => account.id == this.user.uid)[0]
      },
      totalValue: function() {
        let items = this.items.filter(item => item.created_by == this.mainAccount.default_account)

        var value = 0
        if (items && items.length) {
          for (var i = 0; i < items.length; i++) {
            if (!isNaN(items[i].value)) {
              value += Number(items[i].value)
            }
          }
        }

        if (value > 1000000) {
          value = "";
        } else {
          value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        return value
      },
  },
  methods: {
    logout: function () {
      this.$store.commit('logout')
    }
  }
}
</script>

<style>
/*@media only screen and (max-width:760px){
  div.ui.container {width: 90% !important;}
}*/

body {
  overflow-y: auto !important
}

#app.hasFixedMenu {padding-top: 60px;}

.wrapper>.ui.grid>.ui.container {margin: 15px 0;}
.ui.menu:first-child {border-radius: 0 0 .28571429rem .28571429rem;}

.narrow>.icon {padding-right: 1px !important; margin-right: 0px !important;}

.wrapper .ui.container.grid {
    padding: 30px 0;
}
.grid .grid {
  margin-top: 0;
}
.ui.button>i.icon {margin: 0 !important;}

.ui.stackable.grid {
  margin: 15px 0;
}
</style>
